import entities from './entities';

export default {
  ...entities,
};
